// soundSync.js
var SoundSync = pc.createScript('soundSync');

SoundSync.attributes.add('materialAr', {type:'entity', array: true});

// initialize code called once per entity
SoundSync.prototype.initialize = function() {
    var that = this;
    this.bufferLoadSounds = new Array(0);
    this.roomTextureLoops = new Array(0);
    this.loopCounter = 0;
    this.switcher = true;
    this.channels = new Array(4);
    this.theLoop = 'loop';
    this.allSoundsLoaded = false;
    this.allSoundTexturesLoaded = false;
    this.channelTargeting = new Array(this.materialAr.length);
    this.meshes = this.entity.model.meshInstances;
    this.timer = 0;
    this.music = this.entity.sound;
    this.mSlot = this.music.slots[0];
    this.animation = this.entity.animation;
    this.app.mouse.on(pc.EVENT_MOUSEDOWN, this.onMouseDown, this);
    this.music.on('end', this.onSoundEnd, this);
    this.setChannelTargets();
    this.app.on('soundsLoaded', this.soundsLoaded, this);
    this.app.on('soundTexturesLoaded', this.soundTexturesLoaded, this);
};

SoundSync.prototype.soundsLoaded = function() {
    this.allSoundsLoaded = true;
    this.loadTextureLoops();

};

SoundSync.prototype.soundTexturesLoaded = function() {
    this.allSoundTexturesLoaded = true;
};

SoundSync.prototype.loadSounds = function() {
    var loaded = 0;
    this.bufferLoadSounds = this.app.assets.findByTag('bufferLoops');
    
    for(var cntr = 0; cntr < this.bufferLoadSounds.length; cntr ++){
        var tEnt = this.bufferLoadSounds[cntr];
        var lng = this.bufferLoadSounds.length;
        this.app.assets.load(tEnt);
        this.music.addSlot(tEnt.name, {
                loop: false,
                autoPlay: false,
                asset: tEnt
            });
        tEnt.ready(function (tEnt) {
            loaded += 1;
            if(loaded == lng){
                that.app.fire('soundsLoaded');
            }
        }); 
    }
    


};

SoundSync.prototype.loadTextureLoops = function() {
    var loaded = 0;
    this.roomTextureLoops = this.app.assets.findByTag('roomTextureLoops');
    for(var txtCntr = 0; txtCntr < this.roomTextureLoops.length; txtCntr ++){
        
        var txtEnt = this.roomTextureLoops[txtCntr];
        var txtLng = this.roomTextureLoops.length;
        this.app.assets.load(txtEnt);
        txtEnt.ready(function (txtEnt){
            loaded += 1;
            if(loaded == txtLng){
                that.app.fire('soundTexturesLoaded');
            }
        });
    }
};


SoundSync.prototype.setChannelTargets = function() {

    if(this.loopCounter == 2){
        //console.log('LOOPCOUNTER2 + SOUNDSLOADED: ' + this.allSoundsLoaded);
        this.loopCounter = 0;
        if(this.allSoundsLoaded){
           // console.log('CHANGESOUND');
            this.theLoop = this.bufferLoadSounds[Math.floor(Math.random()*this.bufferLoadSounds.length)].name;
        }
    }
    for(var j = 0; j < this.materialAr.length; j++){
        this.channelTargeting[j] = Math.floor(Math.random() * 4);
    }
    this.loopCounter += 1;
};

SoundSync.prototype.onSoundEnd = function(){
    // this.setChannelTargets();
    // this.app.fire('reTrigger');
    // this.music.play(this.theLoop);
    // this.animation.play('Take 001.glb');
};

SoundSync.prototype.startSound = function(){
    if(this.switcher){
        this.animation.enabled = true;
        this.music.play(this.theLoop);
        this.animation.play('Take 001.glb');
        this.switcher = false; 
    } else {
        this.animation.enabled = false;
        this.music.stop();
        this.switcher = true; 
    }
};

// SoundSync.prototype.onMouseDown = function (event) {
//     if(this.oneTime){
//         this.music.play('loop');
//         this.animation.play('Take 001.glb');
//         this.oneTime = false;
//     }

// };


// update code called every frame
SoundSync.prototype.update = function(dt) {
    this.channels[0] = this.meshes[0].node.getLocalScale().z;
    this.channels[1] = this.meshes[1].node.getLocalScale().z;
    this.channels[2] = this.meshes[2].node.getLocalScale().z;
    this.channels[3] = this.meshes[3].node.getLocalScale().z;

    for(var i = 0; i < this.materialAr.length; i++){
        this.materialAr[i].model.meshInstances[0].material.emissiveIntensity = this.channels[this.channelTargeting[i]];
        this.materialAr[i].model.meshInstances[0].material.update();
    }


};


// swap method called for script hot-reloading
// inherit your script state here
// SoundSync.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/

